import React, { memo, useState, useEffect } from 'react'
import {
  BodyText,
  Col,
  Container,
  HeadingText,
  Row,
} from '@paypalcorp/pp-react'
import { PrivacyHubLink } from './common'
import { Message } from '@paypalcorp/worldready-react'
import { dataUsageConfig } from '../../config/privacy-hub'
import { bool, object } from 'prop-types'
import serverData from '../../utils/server-data'

const PrivacyHubDataBannerSection = memo(() => (
  <Container className="privacy-hub-data-banner-section-container">
    <Row noGutters className="privacy-hub-align-items-center">
      <Col
        xs={12}
        md={6}
        className="privacy-hub-data-banner-content-container privacy-hub-col-spacing"
      >
        <HeadingText
          size="hero"
          className="privacy-hub-display-text"
          id="privacyhubDataHeading"
        >
          <Message id="privacyhub.data.banner.title" />
        </HeadingText>
        <BodyText
          className="privacy-hub-body-text privacy-hub-data-banner-description"
          id="privacyhubDataDesc"
        >
          <Message id="privacyhub.data.banner.desc" />
        </BodyText>
      </Col>
      <Col xs={12} md={6} className="privacy-hub-text-align-center">
        <img
          src={`https://${serverData.cdnHostName}/privacyhub/topic-bubble-illustration.svg`}
          alt="topic-bubble"
          className="privacy-hub-data-banner-image"
        />
      </Col>
    </Row>
  </Container>
))

PrivacyHubDataBannerSection.displayName = 'PrivacyHubDataBannerSection'

const PrivacyHubDataSection = memo(
  ({ image, content, orderChange = false }) => (
    <Container className="privacy-hub-data-section-container">
      <Row noGutters className="privacy-hub-align-items-center">
        <Col
          className="privacy-hub-text-align-center privacy-hub-data-image-container"
          xs={12}
          md={{ span: 6, order: orderChange ? 2 : 1 }}
        >
          <img src={image.src} alt={image.alt} className={image.classname} />
        </Col>
        <Col xs={12} md={{ span: 6, order: orderChange ? 1 : 2 }}>
          <HeadingText
            size="sm"
            className="privacy-hub-others-page-title"
            id={`${content.name}Title`}
          >
            <Message id={content.title} />
          </HeadingText>
          <div className="privacy-hub-data-content-description">
            {content.desc1 && (
              <BodyText
                className="privacy-hub-body-text privacy-hub-data-content-text"
                id={`${content.name}Desc1`}
              >
                <Message id={content.desc1} />
              </BodyText>
            )}
            {content.desc2 && (
              <BodyText
                className="privacy-hub-body-text"
                id={`${content.name}Desc2`}
              >
                <Message id={content.desc2} />
              </BodyText>
            )}
          </div>
          <PrivacyHubLink
            message={content.link}
            href={content.href}
            name={content.name}
            id={content.id}
          />
        </Col>
      </Row>
    </Container>
  ),
)

PrivacyHubDataSection.propTypes = {
  image: object.isRequired,
  content: object.isRequired,
  orderChange: bool,
}

PrivacyHubDataSection.displayName = 'PrivacyHubDataSection'

const PrivacyHubData = memo(() => {
  const [dataSections, setDataSection] = useState(null)

  useEffect(() => {
    let orderChange = true
    const sections = dataUsageConfig.map(({ key, enabled, content, image }) => {
      if (!enabled) {
        return null
      }
      orderChange = !orderChange
      return (
        <PrivacyHubDataSection
          key={key}
          content={content}
          image={image}
          orderChange={orderChange}
        />
      )
    })
    setDataSection(sections)
  }, [])

  return (
    <div id="privacy-hub-data">
      <PrivacyHubDataBannerSection />
      {dataSections}
    </div>
  )
})

PrivacyHubData.displayName = 'PrivacyHubData'

export default PrivacyHubData
